import { Role } from "../../services/__generated__/graphql"

// LMNT role vocabulary. On the wire, custom:role stays "ROOT"/"ADMIN" (so the
// existing AppSync VTL resolvers and Python token decoders keep working); these
// are the user-facing names, kept in sync with the dev-role catalog. See
// docs/user-roles.md.
//   Root  == ROOT  (the Atomic operator role — can manage users + View As)
//   Admin == ADMIN (the standard LMNT app user)
export const ROLE_LABELS: Record<string, string> = {
  [Role.Root]: "Root",
  [Role.Admin]: "Admin",
  [Role.None]: "No role",
}

/** The role that grants access to the Admin page + user management. */
export const ADMIN_ROLE: Role = Role.Root

export function roleLabel(role: string | null | undefined): string {
  if (!role) return "—"
  return ROLE_LABELS[role] ?? role
}

export interface RoleOption {
  value: Role
  label: string
}

/** Roles an admin may assign when inviting or updating a user. */
export const ASSIGNABLE_ROLES: RoleOption[] = [
  { value: Role.Root, label: ROLE_LABELS[Role.Root] },
  { value: Role.Admin, label: ROLE_LABELS[Role.Admin] },
]
